import type { LocationQuery, LocationQueryValue, RouteLocationNormalizedLoaded } from 'vue-router';

export interface CrossDirectoryLocationRoute {
  params: Record<string, string>;
  query: LocationQuery;
}

export const AGENCY_DIRECTORY_STASH_QUERY_KEYS = [
  'listingType',
  'sortBy',
  'includeChildren',
] as const;

export type AgencyDirectoryStashQueryKey = (typeof AGENCY_DIRECTORY_STASH_QUERY_KEYS)[number];

export type AgencyDirectoryStashQuery = Partial<
  Record<AgencyDirectoryStashQueryKey, LocationQueryValue>
>;

/** Merges stashed agency filters into a cross-directory query (never restores page). */
export const mergeAgencyDirectoryStashQuery = (
  baseQuery: LocationQuery,
  stash: AgencyDirectoryStashQuery,
): LocationQuery => ({
  ...baseQuery,
  ...stash,
});

/** Location params and query shared when switching between agency and agent directory. */
export const buildCrossDirectoryLocationRoute = (
  route: Pick<RouteLocationNormalizedLoaded, 'params' | 'query'>,
  featureToggleQuery: LocationQuery,
): CrossDirectoryLocationRoute => ({
  params: route.params.location ? { location: String(route.params.location) } : {},
  query: {
    ...(route.query.loc ? { loc: route.query.loc } : {}),
    ...featureToggleQuery,
  },
});
